<template>
    <v-select
        v-bind="$attrs"
        :value="modelValue"
        @input="$emit('update:modelValue', $event)"
        :items="items"
        :label="label"
        outlined
        dense
        color="primary"
    ></v-select>
</template>

<script>
    export default{
        inheritAttrs: false,
        model : {
            prop : 'modelValue',
            event : 'update:modelValue'
        },
        props: {
            items: {
                type: Array,
                default: () => []
            },
            label: {
                type: String,
                default: 'Select'
            },
            modelValue: {
                type: [String, Number, Object],
                default: null
            }
        },
        emits : ['update:modelValue'],
    }
</script>

<style scoped>
.campo-texto-azul ::v-deep .v-input__control,
.campo-texto-azul ::v-deep .v-input__slot {
  min-height: 56px !important;
}
.campo-texto-azul ::v-deep fieldset {
  border-color: #002245 !important;
  border-width: 1.5px !important;
  border-radius: 8px !important;
}
.campo-texto-azul ::v-deep .v-select__selection,
.campo-texto-azul ::v-deep input {
  color: #002245 !important;
  font-weight: 600;
}
.campo-texto-azul ::v-deep .v-label {
  color: #002245 !important;
  font-weight: 600;
}
.campo-texto-azul ::v-deep .v-icon {
  color: #002245 !important;
}
</style>